<template>
    <section>
        <div class="container-fluid">
            <div class="row">
                <div class="col-12 grid-margin">
                    <div class="card">
                        <div class="card-header">
                            <h5 class="mb-0">Lista utenti</h5>
                        </div>
                        <div class="card-body p-0">
                            <paginated-table v-if="users.data" v-model="query" :columns="columns" :data="users.data" :total="users.total">
                                <template slot="id" slot-scope="props">
                                    {{ props.row.id || '--'}}
                                </template>
                                <template slot="username" slot-scope="props">
                                    {{ props.row.username || '--'}}
                                </template>
                                <template slot="type" slot-scope="props">
                                    <font-awesome-icon
                                        :icon="props.row.type == 1 ? 'user-cog' : 'user'"
                                        :class="props.row.type == 1 ? 'text-danger' : ''"
                                    />
                                </template>
                                <template slot="image" slot-scope="props">
                                    <template v-if="props.row.image">
                                        <img class="user-thumb-mini" :src="props.row.image" alt="" />
                                    </template>
                                    <template v-else>
                                        <img class="user-thumb-mini" :src="require(`@/assets/images/default.png`)" alt="" />
                                    </template>
                                </template>
                                <template slot="email" slot-scope="props">
                                    {{ props.row.email || '--'}}
                                </template>
                                <template slot="parent" slot-scope="props">
                                    <span v-if="props.row.parent">{{ props.row.parent.username }}</span>
                                    <span v-else>--</span>
                                </template>
                                <template slot="created_by" slot-scope="props">
                                    {{ props.row.created_by === -1 ? 'Import' : 'Admin '}}
                                </template>
                                <template slot="created_at" slot-scope="props">
                                    <span>{{ $date(props.row.created_at).format('DD-MM-YYYY') }}</span><br>
                                    <small><font-awesome-icon :icon="['far', 'clock']" /> {{ $date(props.row.created_at).format('HH:mm') }}</small>
                                </template>
                                <template slot="updated_at" slot-scope="props">
                                    <span>{{ $date(props.row.updated_at).format('DD-MM-YYYY') }}</span><br>
                                    <small><font-awesome-icon :icon="['far', 'clock']" /> {{ $date(props.row.updated_at).format('HH:mm') }}</small>
                                </template>
                                <template slot="actions" slot-scope="props">
                                    <div class="btn-group" role="group" aria-label="">
                                        <a title="Modifica utente" href="javascript:;" class="btn btn-sm btn-info" @click="editUser(props.row.id)">
                                            <font-awesome-icon :icon="['far', 'edit']" /> <span>MODIFICA</span>
                                        </a>
                                        <a v-if="props.row.id !== 1" title="Elimina utente" href="javascript:;" class="btn btn-sm btn-danger" @click="deleteUser(props.row.id)">
                                            <font-awesome-icon icon="trash-alt" /> <span>ELIMINA</span>
                                        </a>
                                    </div>
                                </template>
                            </paginated-table>
                        </div>
                        <!-- <div class="card-footer" v-if="currentUser.type === 1">
                            <button @click="addUser" class="btn btn-success">
                                <font-awesome-icon icon="plus" size="sm" /> AGGIUNGI UTENTE
                            </button>
                        </div> -->
                    </div>
                </div>
            </div>
        </div>
        <user-modal :user="localUser"></user-modal>
    </section>
</template>
<script>
import {
    User
} from '@/models/User'
import {
    mapGetters
} from 'vuex'
import {
    GET_LIST,
    DELETE
} from '@/store/actions.type'
import {
    MODULE_NAME
} from '@/store/modules/users.module'
const DEFAULT_QUERY = {
    _page: 1,
    _limit: 10,
    _sort: '',
    _asc: 1
}
export default {
    name: 'users-list-paginated',
    mounted () {
        this.fetchUsers()
    },
    data () {
        return {
            localUser: new User(),
            columns: {
                // id: {
                //     label: 'id',
                //     sortable: true,
                //     priority: 5,
                //     align: 'center'
                // },
                image: {
                    label: '',
                    priority: 5,
                    align: 'center'
                },
                username: {
                    label: 'Matricola',
                    sortable: true
                },
                type: {
                    label: 'Tipo',
                    align: 'center'
                },
                email: {
                    label: 'Email'
                },
                // parent: {
                //     label: 'Genitore',
                //     priority: 4
                // },
                created_by: {
                    label: 'Creato da'
                },
                created_at: {
                    label: 'Data creazione',
                    sortable: true,
                    priority: 3
                },
                // updated_at: {
                //     label: 'Data modifica',
                //     sortable: true,
                //     priority: 4
                // },
                actions: {
                    label: '',
                    align: 'right'
                }
            }
        }
    },
    computed: {
        ...mapGetters({
            users: `${MODULE_NAME}/getList`
        }),
        ...mapGetters([
            'isAuthenticated',
            'currentUser'
        ]),
        query: {
            get () {
                return Object.keys(this.$route.query).length == 0 ? DEFAULT_QUERY : this.$route.query
            },
            set (new_query) {
                this.$router.replace({
                    query: {
                        ...new_query
                    }
                })
            }
        }
    },
    watch: {
        $route () {
            this.$store.dispatch(`${MODULE_NAME}/${GET_LIST}`, {
                query: this.query
            })
        }
    },
    methods: {
        fetchUsers () {
            this.$store.dispatch(`${MODULE_NAME}/${GET_LIST}`, {
                query: this.query
            })
        },
        addUser () {
            this.localUser = new User()
            this.$modal.show('user-modal')
        },
        editUser (userId) {
            this.$router.push({
                name: 'user-detail',
                params: {
                    id: userId
                }
            })
        },
        deleteUser (userId) {
            // L'utente non può eliminare se stesso!
            if (userId === this.currentUser.id) {
                this.$swal({
                    title: 'ATTENZIONE!',
                    text: 'Non puoi eliminare te stesso!',
                    type: 'warning'
                })
                return false
            }
            this.$swal({
                title: 'Sei sicuro?',
                text: 'Una volta eliminato non potrai più recuperare questo utente!',
                type: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Si, eliminalo!'
            }).then((willDelete) => {
                if (willDelete.value) {
                    this.$store.dispatch(`${MODULE_NAME}/${DELETE}`, userId).then(() => {
                        this.fetchUsers()
                    })
                } else {
                    this.$swal('Bene!', 'L\'utente è salvo!')
                }
            })
        }
    },
    components: {
        UserModal: () => import('./UserModal'),
        PaginatedTable: () => import('@/components/PaginatedTable')
    }
}
</script>
